import React, { useEffect, useRef, useState } from 'react';
import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';
import AudioTrimmer from './AudioTrimmer.js';
import LoadingIndicator from '@/components/LoadingIndicator.js';

const VideoTrimmer = ({ file, onTrimmed }) => {
  const [audioBlob, setAudioBlob] = useState(null);
  const [convertedFile, setConvertedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const version = '1.1.0';

  useEffect(() => {
    const ffmpeg = createFFmpeg({
      log: false,
      corePath: `/ffmpeg/ffmpeg-core.js?v=${version}`,
    });

    const extractAudioFromVideo = async () => {
      await ffmpeg.load();

      await new Promise((resolve) => setTimeout(resolve, 500));

      const filesInFS = ffmpeg.FS('readdir', '/');
      const systemDirectories = ['tmp', 'home', 'dev', 'proc', '.', '..'];
      filesInFS.forEach((fileToDelete) => {
        if (!systemDirectories.includes(fileToDelete)) {
          try {
            const stats = ffmpeg.FS('stat', fileToDelete);
            if (stats.mode & 0o040000) {
              // 判断是否为目录
              ffmpeg.FS('rmdir', fileToDelete); // 删除目录
            } else {
              ffmpeg.FS('unlink', fileToDelete); // 删除文件
            }
          } catch (error) {
            console.warn(`删除 ${fileToDelete} 失败:`, error);
          }
        }
      });

      const videoData = await fetchFile(file);
      ffmpeg.FS('writeFile', 'input.mp4', videoData);

      const outputFileName = 'output.wav';

      try {
        await ffmpeg.run(
          '-i',
          'input.mp4',
          '-vn', // 去掉视频
          '-acodec',
          'pcm_s16le',
          '-ar',
          '44100',
          '-ac',
          '2',
          outputFileName
        );
        const filesInFS = await ffmpeg.FS('readdir', '/');
        if (!filesInFS.includes(outputFileName)) {
          alert('视频中不包含音频轨道');
          return;
        }

        const audioData = ffmpeg.FS('readFile', outputFileName);
        const audioBlob = new Blob([audioData.buffer], { type: 'audio/wav' });
        setAudioBlob(audioBlob);

        const audioFile = new File([audioBlob], 'converted.wav', {
          type: 'audio/wav',
        });
        setConvertedFile(audioFile);
      } catch (err) {
        alert('视频中不包含音频轨道');
        console.warn('ffmpeg 提取音轨失败:', err);
      } finally {
        setIsLoading(false);
      }
    };

    extractAudioFromVideo();
  }, [file]);

  return isLoading ? (
    <LoadingIndicator label={'视频转音频中'} containerClassName={'flex-row'} />
  ) : (
    <>
      {convertedFile ? (
        <AudioTrimmer file={convertedFile} onTrimmed={onTrimmed} />
      ) : null}
    </>
  );
};

export default VideoTrimmer;
